interface ErrorState {
	message: string;
	show: boolean;
}

export interface EmailFieldState {
	value: string;
	error: ErrorState;
	valid: boolean | null;
}

export type Action =
	| { type: 'SET_EMAIL_VALUE'; payload: string }
	| { type: 'SET_EMAIL_ERROR'; payload: string }
	| { type: 'REMOVE_EMAIL_ERROR' }
	| { type: 'SHOW_EMAIL_ERROR' }
	| { type: 'HIDE_EMAIL_ERROR' }
	| { type: 'RESET_EMAIL_VALIDITY' }
	| { type: 'SET_EMAIL_VALIDITY'; payload: boolean | null };

const Reducer = (state: EmailFieldState, action: Action): EmailFieldState => {
	switch (action.type) {
		case 'SET_EMAIL_VALUE':
			return {
				...state,
				value: action.payload,
			};
		case 'SET_EMAIL_ERROR':
			return {
				...state,
				error: { ...state.error, message: action.payload },
			};
		case 'REMOVE_EMAIL_ERROR':
			return {
				...state,
				error: { ...state.error, message: '', show: false },
			};
		case 'SHOW_EMAIL_ERROR':
			return {
				...state,
				error: { ...state.error, show: true },
			};
		case 'HIDE_EMAIL_ERROR':
			return {
				...state,
				error: { ...state.error, show: false },
			};
		case 'RESET_EMAIL_VALIDITY':
			return {
				...state,
				valid: null,
			};
		case 'SET_EMAIL_VALIDITY':
			return {
				...state,
				valid: action.payload,
			};
		default:
			return state;
	}
};

export default Reducer;
